import { render } from "./DuelsGameFair.vue?vue&type=template&id=327436e8&scoped=true"
import script from "./DuelsGameFair.vue?vue&type=script&lang=js"
export * from "./DuelsGameFair.vue?vue&type=script&lang=js"

import "./DuelsGameFair.vue?vue&type=style&index=0&id=327436e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327436e8"]])

export default __exports__